import classNames from "classnames";

const PetNamePill = ({
  petName,
  isSelected,
  "data-test-id": dataTestId,
}: {
  petName?: string;
  isSelected?: boolean;
  "data-test-id"?: string;
}): JSX.Element => (
  <p
    data-test-id={dataTestId}
    className={classNames(
      "inline-block rounded-full text-xs leading-5 my-1 px-2 overflow-hidden text-ellipsis whitespace-nowrap",
      {
        "bg-lightest": !isSelected,
        "bg-white": isSelected,
        invisible: !petName,
      },
    )}
  >
    {petName || "No pet selected"}
  </p>
);

export default PetNamePill;
